import { markReceiptCancellationAsRejected, markReceiptCancellationAsVerified } from "../../screens/payments/components/receiptCancelVerification/receiptCancelVerification";
import { holidayDateVerificationForFormField } from "../../screens/assignment/components/stateHolidays/stateHolidays";
import { downloadLoanSummaryErrorFile } from "../../screens/loans/downloadLoanSummaryErrorFile";
import { approveOrRejectPendingVerificationRecord, approvePendingVerificationRecords, rejectPendingVerificationRecords,approveOrRejectRepoChargesRecord, markStatusOfEntityWithPayload, acceptRejectOrCancelVendorInvoice, regenerateVendorInvoice } from "../../services/pendingVerificationHandler";
import { markReceiptCancellationAsApproved } from "../../screens/payments/components/receiptCancelApproval/receiptCancelApproval";
import { markSpisCancellationAsApproved, markSpisCancellationAsRejected } from "../../screens/payments/components/spisCancelApproval/spisCancelApproval";   
import { approveOrRejectRepoCharges } from "../../screens/reposession/components/repoChargesApprove/repoChargesApproval";
import { approveOrRejectRepoKitCancellation } from "../../screens/reposession/components/repoKitCancelApproval/repoKitCancelApproval";
import { approveOrRejectRepoRelease } from "../../screens/reposession/components/repoReleaseApproval/repoReleaseApproval";
import { approveOrRejectRepoAuction } from "../../screens/reposession/components/repoAuctionApproval/repoAuctionApproval";
import { saveRecordAsDraft } from "../../components/recordDetails/detailsPageCommonsUtils";
import { updateOrCreateRecordsUsingBulkApi } from "../../services/platformTopActionsOnBulkRecHandler";


export const javascriptActionFns: Map<string, Function> = new Map([
    ["approvePendingVerificationRecords", approvePendingVerificationRecords],
    ["rejectPendingVerificationRecords", rejectPendingVerificationRecords],
    ["updateOrCreateRecordsUsingBulkApi", updateOrCreateRecordsUsingBulkApi]
]);

export const javascriptRecordActionFns: Map<string, Function> = new Map([
    ["approveOrRejectPendingVerificationRecord", approveOrRejectPendingVerificationRecord],
    ["downloadLoanSummaryErrorFile", downloadLoanSummaryErrorFile],
    ["approveOrRejectRepoChargesRecord", approveOrRejectRepoChargesRecord],
    ["markReceiptCancellationAsVerified", markReceiptCancellationAsVerified],
    ["markReceiptCancellationAsApproved", markReceiptCancellationAsApproved],
    ["markReceiptCancellationAsRejected", markReceiptCancellationAsRejected],
    ["markSpisCancellationAsApproved", markSpisCancellationAsApproved],
    ["markSpisCancellationAsRejected", markSpisCancellationAsRejected],
    ["markStatusOfRepoCharges", approveOrRejectRepoCharges],
    ["saveRecordAsDraft", saveRecordAsDraft],
    ["approveOrRejectRepoKitCancellation", approveOrRejectRepoKitCancellation],
    ["approveOrRejectRepoRelease", approveOrRejectRepoRelease],
    ["approveOrRejectRepoAuction", approveOrRejectRepoAuction],
    ["approveOrRejectVendorInvoiceRecord", acceptRejectOrCancelVendorInvoice],
    ["regenerateVendorInvoice", regenerateVendorInvoice],
    ["markStatusOfEntityWithPayload", markStatusOfEntityWithPayload]

]);

export const javascriptRecordDetailFieldLevelHookFns: Map<string, Function> = new Map([
    ["verifyIfItIsPublicHoliday", holidayDateVerificationForFormField],
]);

export const javascriptRowActionFns: Map<string, Function> = new Map([
    ["approveOrRejectRepoChargesRecord", approveOrRejectRepoChargesRecord]
]);
